// extracted by mini-css-extract-plugin
module.exports = {"holder":"TextSelection--holder","inputGroup":"TextSelection--inputGroup","helpQuestionCircle":"TextSelection--helpQuestionCircle"};